import React from 'react';
import {Feature} from "../../../gd/access-control/feature-access/const"

export enum ButtonSize {
    STANDARD    = '36',
    SMALL       = '30',
    SMALLER     = '28',
    TINY        = '26'
}

export enum ButtonType {
    PRIMARY             = 'primary',
    PRIMARY_RED         = 'primary-red',
    SECONDARY           = 'secondary',
    SECONDARY_RED       = 'secondary_red',
    SECONDARY_DASHED    = 'secondary_dashed',
    SECONDARY_BUSY      = 'secondary-busy',
    ON_WHITE            = 'on-white',
    BUSY                = 'busy',
    WHITE               = 'white',
    GRAY                = 'gray',
    DISABLED            = 'disabled',
}

export type ButtonProps = {
    type?           : 'primary' | 'secondary' | 'busy' |'secondary-busy'|'disabled'|'on-white'|'on-gray'|'normal'| ButtonType | any,
    size            : ButtonSize | '36' | '30' | '26'
    disabled?       : boolean
    onClick?        : callback
    icon?           : string
    label?          : string

    iconPosition?   : 'left' | 'right'
    style?          : any
    className?      : string

    isPro?          : boolean
    proFeature?     : Feature

    href?            : string
    openNewWindow?  : boolean
}


export default class Button extends React.Component<ButtonProps,any> {

    static defaultProps = {
        isPro           : false,
        type            : ButtonType.PRIMARY,
        size            : ButtonSize.STANDARD, // ButtonSize.SMALL // WHY ????
        iconPosition    : 'left',
        disabled        : false
    }

    state = {
        type: this.props.type
    }

    componentDidUpdate(prevProps:any, prevState:any) {
        if(prevState.type !== this.props.type) {
            this.setState({
                type: this.props.type
            });
        }
    }

    setType(value:any) {
        if (['primary','normal','secondary','busy','disabled'].includes(value)) {
            this.setState({
                type: value
            });
        }
    }

    get isProLocked(): boolean {
        return this.props.isPro && !gd.company.license.isPro
    }

    onClick = (e:React.SyntheticEvent) => {

        if (this.isProLocked) {
            e.preventDefault()
            e.stopPropagation()
            gd.modals.other.upgradeToPro(this.props.proFeature)
            return false
        }

        if (
            ['busy', 'disabled'].includes(this.state.type)
            || this.props.disabled
        ) {
            e.preventDefault()
        } else {
            this.props.onClick?.(e)
        }
    }

    render() {

        let classes = Classes('ui5-button', 'flex', this.props.className, {
            's36'               : this.props.size === ButtonSize.STANDARD,
            's30'               : this.props.size === ButtonSize.SMALL,
            's28'               : this.props.size === ButtonSize.SMALLER,
            's26'               : this.props.size === ButtonSize.TINY,
            'primary'           : this.state.type === 'primary',
            'red'               : this.state.type === ButtonType.PRIMARY_RED,
            'secondary'         : this.state.type === 'secondary',
            'secondary-red'     : this.state.type === ButtonType.SECONDARY_RED,
            'secondary-dashed'  : this.state.type === ButtonType.SECONDARY_DASHED,
            'busy'              : this.state.type === 'busy',
            'secondary-busy'    : this.state.type === 'secondary-busy',
            'disabled'          : this.state.type === 'disabled' || this.props.disabled,
            'white'             : this.state.type === 'white',
            'on-white'          : this.state.type === 'on-white',
            'on-gray'           : this.state.type === 'on-gray',
            'selected'          : this.state.type === 'selected',
            'with-icon'         : !!this.props.icon,
        });
        let buttonIcon = null;
        let buttonLabel : any = this.props.label;

        if (this.props.icon) {

            // @ts-ignore
            const iconClass = Classes("icon", this.props.icon, {
                'm-r-10'    : !!this.props.label && this.props.iconPosition === 'left',
                'm-l-10'    : !!this.props.label && this.props.iconPosition === 'right'
            })

            buttonIcon = <span key="icon" className={iconClass}/>
            buttonLabel = !!this.props.label && <span key="txt" className="txt">{this.props.label}</span>
        }

        if (this.state.type === ButtonType.BUSY) {
            buttonLabel = null;
            buttonIcon = <div className="ui5-busy-dots s6 color-action-to-pale"/>
            // classes = Classes(classes, 'min-w-100') // add min width - use props.classes
        }

        if (this.state.type === 'secondary-busy') {
            buttonLabel = null;
            buttonIcon = <div className="ui5-busy-dots s8 color-pale-to-action"/>
        }

        let content;
        switch(this.props.iconPosition) {
            case 'left' : content = <React.Fragment>{buttonIcon}{buttonLabel}</React.Fragment>; break;
            case 'right': content = <React.Fragment>{buttonLabel}{buttonIcon}</React.Fragment>; break;
        }

        if (!this.props.href) {

            // this is button

            return (
                <div className  = {classes}
                     style      = {this.props.style}
                     onClick    = {this.onClick}
                >
                    {this.isProLocked &&
                        <div className="ui5-ico-pro s-28"/>
                    }
                    {content}
                </div>
            )
        } else {

            // This is link
            let target = this.props.openNewWindow ? "_blank" : undefined

            return (
                <a className    = {classes}
                   style        = {this.props.style}
                   href         = {this.props.href}
                   target       = {target}
                >
                    {this.isProLocked &&
                        <div className="ui5-ico-pro s-28"/>
                    }
                    {content}
                </a>
            )
        }
    }
}
